// extracted by mini-css-extract-plugin
module.exports = {"intro":"Intro_intro__3Dyi5","title":"Intro_title__1eSVu","subtitle":"Intro_subtitle__3F3yk"};